<template>
  <router-view></router-view>
</template>

<script>
import { getAllApps } from '@/api/app.js'

export default {
  beforeCreate: function () {
      getAllApps()
          .then(apps => this.$store.commit('saveApps', apps))
          .catch(() => this.$store.commit('saveApps', []))
  }
}
</script>
